(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();

      this.activeSlider = {};
      this.sliders = [];
      this.controls = null;
      this.controlsWrapper = this.querySelector('[data-controls-wrapper]');
      this.progressBar = this.querySelector('[data-progress-bar]');
      this.tabs = this.querySelectorAll('[data-tab]');
      this.breakpoints = {
        desktop: 990
      };
    }

    connectedCallback() {
      this.initSlider();

      if (this.tabs) {
        [...this.tabs].forEach(tab => {
          tab.addEventListener('click', this._handleTabClick.bind(this))
        })
      }
    }

    /**
     * Initialize slider.
     * @param {String} query - Selector query for slider element
     * @returns 
     */
    initSlider(query = '.splide') {
      const sliderList = this.querySelector(query);

      if (!sliderList) return;

      this.controls = this.querySelectorAll('[data-control]');
      this.controls.forEach((control) => {
        control.addEventListener('click', this.onControlClick.bind(this));
      });
      const slider = new Splide(this.querySelector(query), {
        trimSpace: 'move',
        waitForTransition: true,
        flickMaxPages: 0.5,
        fixedWidth: '310px',
        gap: '20.25px',
        pagination: false,
        arrows: false,
        speed: 300,
        easing: 'ease-in-out',
        breakpoints: {
          [this.breakpoints.desktop]: {
            fixedWidth: '200px',
            gap: '9.75px'
          }
        }
      }).mount();

      this.sliders.push(slider);
      this.activeSlider = slider;
      this.initProgressBar(slider);
    }

    /**
     * Handle tab click, when multiple sliders.
     * Updates selected button and which slider is visible,
     * initializing Splide if necessary.
     * @param {Event} event
     * 
     */
    _handleTabClick(event) {
      const index = event.target.dataset.blockIndex;

      this.querySelector('[data-tab][aria-selected="true"]').setAttribute('aria-selected', "false");
      event.target.setAttribute('aria-selected', "true");

      const query = `.splide[data-block-index="${index}"]`
      const sliderEl = this.querySelector(query);

      const splideEls = this.querySelectorAll('.splide');
      splideEls.forEach(element => element.classList.add('hidden'));

      if (!sliderEl.classList.contains('is-initialized')) {
        this.initSlider(query);
      } else {
        const splideObj = this.sliders.find(object => object.root == sliderEl);
        this.activeSlider = splideObj;
        this.activeSlider.go(0);
        this.progressBar.style.width = 0;
      }

      sliderEl.classList.remove('hidden');
    }

    /**
     * Initialize progress bar UI for mobile.
     * @param {Object} slider - Splide slider object
     */
    initProgressBar(slider) {  
      const bar = this.querySelector('[data-progress-bar]')

      slider.on( 'mounted move', function () {
        var end  = slider.Components.Controller.getEnd() + 1;
        var rate = Math.min( ( slider.index + 1 ) / end, 1 );
        bar.style.width = String( 100 * rate ) + '%';
      } );
    }

    onControlClick(event) {
      event.preventDefault();

      if (!this.activeSlider) {
        return;
      }

      const action = event.target.hasAttribute('data-prev') ? '<' : '>';

      this.activeSlider.go(action);
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();
